var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurServicesSectionThreeArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 239,
    viewBox: "0 0 144 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-40 0V239L70 119.5L-40 0Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0002 210.446L38.2835 225.73L128.365 135.648L128.387 135.67L143.67 120.386L143.648 120.365L143.67 120.343L128.387 105.06L128.365 105.082L38.2835 14.9999L23.0002 30.2832L113.082 120.365L23.0002 210.446Z",
    fill: "#373F68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurServicesSectionThreeArrowLeft);
export default __webpack_public_path__ + "static/media/our-services-section-three-arrow-left.8c99ce2a687158a33efa17f09456999e.svg";
export { ForwardRef as ReactComponent };